import { BASEURL } from '../../../config';
import axios from 'axios';
import authAxios from '../../../Config/AuthAxios';
import { message } from 'antd';
import { id } from 'date-fns/locale';

export const workspace_listApi = async (search, sort) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `workspace/list?search=${search}&sort_by=${sort}`,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_TeamMemberApi = async () => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + 'team-members',
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_CreateApi = async (data) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + 'workspace/create',
            data: JSON.stringify(data),
        });

        return res;
    } catch (err) {
        return err;
    }
};
export const upload_videoGuideCreateApi = async (formData) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
            method: 'POST',
            url: BASEURL + 'video/create',
            data: formData,
        });

        return res;
    } catch (err) {
        return err;
    }
};

// export const videoGuide_listAPI = async (search) => {
//   try {
//     const token = localStorage.getItem('token');
//     const res = await authAxios({
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//       method: 'GET',
//       url: BASEURL + `video/list${search ? `?keyword=${search}` : ''}`,
//     });

//     return res;
//   } catch (err) {
//     return err;
//   }
// };
export const videoGuide_listAPI = async (search) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `video/list?keyword=${search}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const videoGuide_EditlistAPI = async (search) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `video/list`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_Details_Api = async (workspaceId) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `workspace/${workspaceId}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_Folder_CreateApi = async (workspaceId, data) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + `workspace/${workspaceId}/folders/create`,
            data: JSON.stringify(data),
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_FolderList_Api = async (workspaceId, search, sort) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `workspace/${workspaceId}/folders/list?search=${search}&sortBy=${sort}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_Supporting_DocumentFolder_CreateApi_Restrict = async (
    workspaceId,
    data
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url:
                BASEURL +
                `workspace/${workspaceId}/supporting-documents/folders/create`,
            data: JSON.stringify(data),
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_Supporting_DocumentFolder_ListApi = async (
    workspaceId,
    search,
    sort
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `workspace/${workspaceId}/output-format/folders/list?search=${search}&sortBy=${sort}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_Output_Template_Folder_CreateApi = async (
    workspaceId,
    data
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url:
                BASEURL +
                `workspace/${workspaceId}/output-template/folders/create`,
            data: JSON.stringify(data),
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_Output_Teamplate_Folder_ListApi = async (
    workspaceId,
    search,
    sort
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `workspace/${workspaceId}/output-format/folders/list?search=${search}&sortBy=${sort}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_Support_DocumentsList_Api = async (
    workspaceId,
    search,
    sort
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `workspace/${workspaceId}/supporting-documents/folders/list?search=${search}&sortBy=${sort}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_Supporting_Documents_Data_Details_ListApi = async (
    workspaceId,
    setDatadetalisid,
    search,
    sort,
    page
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `workspace/${workspaceId}/supporting-documents/folders/${setDatadetalisid}/content?search=${search}&sortBy=${sort}&page=${page}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_Supporting_Documents_Data_Details_Out_Put_ListApi =
    async (workspaceId, setDatadetalisoutputid, search, sort, page) => {
        try {
            const token = localStorage.getItem('token');
            const res = await authAxios({
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                method: 'GET',
                url:
                    BASEURL +
                    `workspace/${workspaceId}/output-format/folders/${setDatadetalisoutputid}/content?search=${search}&sortBy=${sort}&page=${page}`,
            });

            return res;
        } catch (err) {
            return err;
        }
    };

export const workspace_QuickList_Api = async (
    workspaceId,
    search,
    sort,
    page
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `workspace/${workspaceId}/quick-actions/list?search=${search}&sortBy=${sort}&page=${page}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_QuickActionsList_Api = async (
    workspaceId,
    actionworkspaceId,
    search,
    sort,
    page
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `workspace/${workspaceId}/folders/${actionworkspaceId}/quick-actions/list?search=${search}&sortBy=${sort}&page=${page}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const dashboard_Quick_Actions_Created_Api = async () => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `dashboard/get-quick-actions-created`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const dashboard_Time_Created_Api = async (value) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `dashboard/get-time-created?date_range=${value}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const dashboard_Recently_Used_Quick_Actions_Api = async (page_data) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `dashboard/get-recently-used-quick-actions?page=${page_data}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const dashboard_Public_Quick_Actions_Api = async (page_data) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `dashboard/get-public-quick-actions?page=${page_data}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const dashboard_Team_Members_Api = async () => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `dashboard/get-team-members`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const dashboard_Bookmarked_Quick_Actions_Api = async (page_data) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `dashboard/get-bookmarked-quick-actions?page=${page_data}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const videoGuide_deleteAPI = async (id) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'DELETE',
            url: BASEURL + `video/delete/${id}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const NotificationsApi = async () => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + 'notifications/recent',
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const DocumentsSupportingOutPutCreateSupportingDocumentsApi = async (
    data
) => {
    try {
        const Data = data;
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + 'output-format',
            data: Data,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const SupportingDocumentsFileUploadApi = async (file) => {
    try {
        const formData = new FormData();
        formData.append('file', file);
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
            method: 'POST',
            url: BASEURL + 'supporting-document/upload-file',
            data: formData,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const DocumentsSupportingCreateSupportingDocumentsApi = async (data) => {
    try {
        const Data = data;
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + 'supporting-document',
            data: Data,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const SupportingDocumentsOutPutFileUploadApi = async (data) => {
    try {
        const formData = new FormData();
        formData.append('file', data);

        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
            method: 'POST',
            url: BASEURL + 'output-format/upload-file',
            data: formData,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const WorkspaceAccessApi = async (workspaceId) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + `workspace/${workspaceId}/request-access`,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const SettingsWorkspaceAnalyticsApi = async (
    search,
    sort,
    page,
    client_id
) => {
    try {
        const token = localStorage.getItem('token');
        const client_id_req = client_id ? `&client_id=` + client_id : '';
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `setting/workspace-analytics?search=${search}&sortBy=${sort}&page=${page}${client_id_req}`,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const EditProfileApi = async (data) => {
    try {
        const Data = {
            first_name: data.firstName,
            last_name: data.lastName,
        };
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'PUT',
            url: BASEURL + 'access-management/users/profile',
            data: Data,
        });

        return res;
    } catch (err) {
        return err;
    }
};

// export const UserProfileApi = async () => {
//   debugger
//   try {
//     const token = localStorage.getItem("token");
//     const res = await authAxios.get(BASEURL + "access-management/users/profile", {
//       headers: {
//         Authorization: token,
//       },
//     });

//     return res;
//   } catch (err) {
//     return err;
//   }
// };

export const UserProfileApi = async () => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + 'access-management/users/profile',
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const EditChangePasswordApi = async (data) => {
    try {
        const Data = {
            old_password: data.currentPassword,
            new_password: data.newPassword,
        };
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'PATCH',
            url: BASEURL + 'access-management/users/change-password',
            data: Data,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const QrgeneratorApi = async () => {
    const token = localStorage.getItem('token');
    try {
        const VerificationData = {
            access_token: token,
        };
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + 'users/setup-mfa',
            data: VerificationData,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const QrverifyCodeApi = async (data) => {
    const token = localStorage.getItem('token');
    try {
        const VerificationData = {
            access_token: token,
            code: data,
        };
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + 'users/verify-mfa-code',
            data: VerificationData,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const SettingsWorkspaceAccessRequestsApi = async () => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + 'setting/workspace-access-requests',
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const SettingsActionWorkspaceAccessRequestsApi = async (data) => {
    try {
        const actionData = {
            action: data.action,
        };
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'PATCH',
            url:
                BASEURL + `setting/${data.id}/action-workspace-access-requests`,
            data: actionData,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const WorkspaceBookmarkToggleApi = async (data) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + `quick-action/${data}/toggle-bookmark`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const Quick_Action_Copy_Api = async (data) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + `quick-action/${data.isQaid}/copy`,
            data: data,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const userManagement_Roles_Api = async () => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `roles`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const userManagement_Roles_List_Api = async () => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `account/role/list`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const userManagement_Create_Roles_Api = async (roleData) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + `account/role/create`,
            data: JSON.stringify(roleData),
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const userManagement_Update_Roles_Api = async (roleData) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'PUT',
            url: BASEURL + `account/role/update`,
            data: JSON.stringify(roleData),
        });

        return res;
    } catch (err) {}
};

export const build_Quick_ActionApi = async (data) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + `quick-action`,
            data: JSON.stringify(data),
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const build_Quick_Action_UpdateApi = async (data, quickActionID) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + `quick-action/${quickActionID}/update`,
            data: JSON.stringify(data),
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const build_Action_Supporting_Document_Quick_RunApi = async (
    data,
    supportingDocumentId
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url:
                BASEURL +
                `supporting-document/${supportingDocumentId}/run-quick-search`,
            data: JSON.stringify(data),
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const build_Quick_Action_CopyApi = async (data, qaId) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + `quick-action/${qaId}/copy`,
            data: JSON.stringify(data),
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const get_User_Support_Documents_Api = async (search) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `supporting-document/list?search=${search}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const get_User_Output_Format_Api = async (search) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `output-format/list?search=${search}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const edit_video_guideAPI = async (id, formData) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
            method: 'POST',
            url: BASEURL + `video/update/${id}`,

            data: formData,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_Support_Documents_Edit_Data_listApi = async (id) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `supporting-document/${id}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_Support_Documents_Update_Data_listApi = async (id) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `supporting-document/${id}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const Supporting_Document_Update_Api = async (data) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + `supporting-document/${data.id}/update`,
            data: JSON.stringify(data),
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_Support_Documents_Output_Edit_Data_listApi = async (
    id
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `output-format/${id}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const Supporting_Document_Output_Update_Api = async (data) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + `output-format/${data.id}/update`,
            data: JSON.stringify(data),
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const BuildQuickDetailsByIdApi = async (id, edit = '') => {
    try {
        const token = localStorage.getItem('token');
        const url = BASEURL + `quick-action/${id}` + (edit ? '/edit' : '');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: url,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const NotificationsReadApi = async (id) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'PATCH',
            url: BASEURL + `notifications/${id}/read`,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const NotificationsReadAllApi = async () => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'PATCH',
            url: BASEURL + `notifications/read-all`,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const accessUser_ManagementList_Api = async (search, page) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `access-management/users/list?search=${search}&page=${page}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const ProductsApi = async () => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `payment/products`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const ProductsPlanApi = async (
    productId,
    quantityId,
    workspaceId,
    coupon
) => {
    try {
        let quantitiesData = {
            quantity: quantityId,
            workspace_id: workspaceId,
            coupon_code: coupon,
        };

        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + `payment/products/${productId}/purchase`,
            data: quantitiesData,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const SubscriptionsApi = async () => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `payment/subscriptions`,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const SubscriptionsCancleApi = async (id) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'PATCH',
            url: BASEURL + `payment/subscriptions/${id}/cancel`,
        });
        return res;
    } catch (err) {
        return err;
    }
};

//RUN-QUICK-ACTION

export const runQuick_Action_Uploadfile_Api = async (data, quickactionId) => {
    try {
        const formData = new FormData();
        formData.append('file', data.file);

        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
            method: 'POST',
            url: BASEURL + `quick-action/${quickactionId}/run/upload-file`,
            data: formData,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const quick_Action_Run_Status_Api = async (
    quickActionId,
    actionRunId
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `quick-action/${quickActionId}/run/status/${actionRunId}
`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const quick_Action_Run_Uplaod_File_With_Fileid_Api = async (
    quickactionId,
    fileId
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `quick-action/${quickactionId}/run/upload-file/${fileId}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const quick_Action_Run_Generate_ChunksApi = async (
    data,
    quickActionId
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + `quick-action/${quickActionId}/run/generate-chunks`,
            data: JSON.stringify(data),
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const quick_Action_Run_Save_Execute_BatchApi = async (
    data,
    quickActionId
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url:
                BASEURL +
                `quick-action/${quickActionId}/run/save-execute-batch`,
            data: JSON.stringify(data),
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const run_Quick_Action_Run_Id_Api = async (data, quickActionId) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + `quick-action/${quickActionId}/run`,
            data: JSON.stringify(data),
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const createPlay_ConversationApi = async (data) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + 'play-chat/conversation',
            data: data,
        });
        // const session_id = res.data.data.session_id;
        // localStorage.setItem('session_id', session_id);
        return res;
    } catch (err) {
        return err;
    }
};

export const getPlay_QueryOptionsAPI = async () => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + 'workspace/list',
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const getPlay_QueryFoldersAPI = async (workspaceId) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `workspace/${workspaceId}/supporting-documents/folders/list`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const getPlay_QuerySupportingFoldersAPI = async (
    foldersId,
    workspaceId,
    page
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `workspace/${workspaceId}/supporting-documents/folders/${foldersId}/content?page=${page}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const createPlay_QUeryLibraryApi = async (data) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + 'play-chat/conversation',
            data: data,
        });
        const session_id = res.data?.data?.session?.id;
        localStorage.setItem('session_id', session_id);

        return res;
    } catch (err) {
        return err;
    }
};

export const getPlay_HistoryAPI = async (page, searchText, sortBy) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `play-chat/conversation/list?page=${page}&search=${searchText}&sort_by=${sortBy}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const getPlayView_HistoryAPI = async (id) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `play-chat/conversation/${id}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const Supporting_Document_Delete_Api = async (id) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + `supporting-document/${id}/delete`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const Supporting_Document_Output_Delete_Api = async (id) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + `output-format/${id}/delete`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_QuickActionsHistory_Api = async (
    workspaceId,
    search,
    sort,
    page
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `workspace/${workspaceId}/history/team?search=${search}&sortBy=${sort}&page=${page}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_QuickActionsSelf_Api = async (
    workspaceId,
    search,
    sort,
    page
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `workspace/${workspaceId}/history/self?search=${search}&sortBy=${sort}&page=${page}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const dashboard_Team_Activity_Api = async (page_data, date) => {
    try {
        const data = { date: date };
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `workspace/history/user/team?page=${page_data}`,
            params: data,
        });

        return res;
    } catch (err) {
        return err;
    }
};
export const Quick_Action_Folder_Api = async (search, ignoreId) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `public-workspace/folders/list?search=${search}&ignore=${ignoreId}`,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const Quick_Action_Folder_List_Api = async (id, data, page) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `public-workspace/folders/${id}?search=${data}&page=${page}`,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const getClientsList = async (searchKey) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `client/list?query=${searchKey}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

//workpace role and permission

export const workspace_Roles_Permission_List_Api = async () => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `workspace/role/list`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_Roles_Permission_Create_Roles_Api = async (roleData) => {
    const token = localStorage.getItem('token');
    try {
        const res = await authAxios({
            method: 'POST',
            url: BASEURL + `workspace/role/create`,
            data: JSON.stringify(roleData),
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_Roles_Permission_Update_Api = async (roleData) => {
    try {
        const res = await authAxios({
            method: 'PUT',
            url: BASEURL + `workspace/role/update`,
            data: JSON.stringify(roleData),
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const create_upload_faq_Api = async (data) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + 'faq/create',
            data: data,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const get_upload_faq_topic_list_api = async () => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + 'faq/topics-list',
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const get_topic_question_list_api = async (id) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `faq/topic-question-list?topic_id=${id}`,
            data: id,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const get_list_of_questions_api = async () => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `faq/question-list`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const delete_parent_data = async (id) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'DELETE',
            url: BASEURL + `faq/delete?question_id=${id}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const update_parent_faq_ques_Api = async (roleData) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'PUT',
            url: BASEURL + `faq/update`,
            data: JSON.stringify(roleData),
        });

        return res;
    } catch (err) {}
};

export const workspaces_SupportingDocumentsId_Api = async (
    workspaceId,
    search
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `workspace/${workspaceId}/supporting-documents/list?search=${search}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const workspaces_OutputFormatsId_Api = async (workspaceId, search) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `workspace/${workspaceId}/output-formats/list?search=${search}`,
        });

        return res;
    } catch (err) {
        return err;
    }
};
export const workspace_User_CreateApi = async (data) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + 'access-management/users/create',
            data: JSON.stringify(data),
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_Role_DeleteAPI = async (roleId) => {
    try {
        const token = localStorage.getItem('token');
        const res = await axios({
            method: 'POST',
            url: BASEURL + `workspace/role/${roleId}/delete`,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const user_Management_Role_DeleteAPI = async (roleId) => {
    try {
        const token = localStorage.getItem('token');
        const res = await axios({
            method: 'POST',
            url: BASEURL + `account/role/${roleId}/delete`,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const Quick_Action_Delete_Api = async (id) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + `quick-action/${id}/delete`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const AccessUserManagementUpdateApi = async (user_id, role_id, data) => {
    try {
        const updateData = {
            role_id: role_id,
            workspace_access: data,
        };
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'PUT',
            url: BASEURL + `access-management/users/${user_id}/admin-update`,
            data: JSON.stringify(updateData),
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const get_supporting_question_list = async (roleData) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `faq/question-list`,
            data: JSON.stringify(roleData),
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const getAllUserList = async (roleData) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `access-management/users/all`,
            data: JSON.stringify(roleData),
        });

        return res.data;
    } catch (err) {
        return err;
    }
};

export const getWorkspacegRuleList = async (roleData) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `workspace/role/list`,
            data: JSON.stringify(roleData),
        });

        return res.data;
    } catch (err) {
        return err;
    }
};

export const addMemberWithRole = async (workspaceId, data) => {
    if (workspaceId) {
        try {
            const token = localStorage.getItem('token');
            const res = await authAxios({
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                method: 'POST',
                url: `${BASEURL}workspace/${workspaceId}/add-user-to-workspace`,
                data: JSON.stringify(data),
            });
            message.success('User Added to workspace');
            return res;
        } catch (err) {
            message.warning("User can't be added to workspace");
            return err;
        }
    }
};

export const upload_DocumentsCreateApi = async (formData) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
            method: 'POST',
            url: BASEURL + 'faq/document/create',
            data: formData,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const UploadDocuments_listAPI = async () => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + 'faq/document/list',
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const edit_uploadDocumentLst = async (formData) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
            method: 'POST',
            url: BASEURL + 'faq/document/update',
            data: formData,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const delete_uploadDocumentLst = async (id) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'DELETE',
            url: BASEURL + `faq/document/delete?id=${id}`,
            data: id,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_Update_api = async (data, id) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'PUT',
            url: BASEURL + `workspace/${id}/update`,
            data: JSON.stringify(data),
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_folder_data = async (id) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `workspace/folder/${id}`,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_folder_update_api = async (data, folderID) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'PUT',
            url: BASEURL + `workspace/folder/${folderID}/update`,
            data: JSON.stringify(data),
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const workpace_deleteAPI = async (id) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'DELETE',
            url: BASEURL + `workspace/${id}/delete`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const workpace_folder_deleteAPI = async (id) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'DELETE',
            url: BASEURL + `workspace/folder/${id}/delete`,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const SettingsUserAnalyticsApi = async (search, sort, time, page) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `setting/user-usage-analytics?search=${search}&time=${time}&sortBy=${sort}&page=${page}`,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const RunQuick_Action_update_OutputName_Api = async (
    data,
    quickActionId,
    actionRunId
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url:
                BASEURL +
                `quick-action/${quickActionId}/run/${actionRunId}/change-name`,
            data: JSON.stringify(data),
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const Run_Quick_Action_History_Api = async (actionRunId) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `quick-action/run/${actionRunId}/history`,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const UserProfileMraApi = async (data) => {
    try {
        const val = {
            is_mfa_enabled: data.is_mfa_enabled,
            token: data.token,
        };
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'PATCH',
            url: BASEURL + 'access-management/users/change-mfa-settings',
            data: val,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const Supporting_Document_Token_Api = async (id, data) => {
    try {
        const val = {
            tokens: data,
        };
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + `workspace/token/${id}/request`,
            data: JSON.stringify(val),
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const SettingsWorkspaceAccessTokenRequestsApi = async (page) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `workspace/token/list?page=${page}`,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const SettingsActionWorkspaceAccessTokenRequestsApi = async (data) => {
    try {
        const actionData = {
            action: data.action,
        };
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + `workspace/token/${data.id}/action`,
            data: actionData,
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const SettingsClientAnalyticsApi = async () => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `client/list`,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const Supporting_Document_User_Delete_Api = async (id) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'DELETE',
            url: BASEURL + `access-management/user/${id}/delete`,
        });
        return res;
    } catch (err) {
        return err;
    }
};
export const SettingsOwnerAnalyticsApi = async (id) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `client/${id}/users/all`,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_Admin_CreateApi = async (data) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + 'setting/admin/create-workspace',
            data: JSON.stringify(data),
        });

        return res;
    } catch (err) {
        return err;
    }
};

export const EnterpriseClientsListApi = async () => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `client/enterprise-clients-list`,
        });
        return res;
    } catch (err) {
        return err;
    }
};

//chat downvote
export const playchat_conversation_downvote_Api = async (
    chatSession,
    messageId
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'PUT',
            url:
                BASEURL +
                `play-chat/conversation/${chatSession}/${messageId}/down-vote`,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const Striped_managed_ClientsListApi = async () => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `client/stripe-managed-clients-list`,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const RunQuick_Action_update_OutputFeedback_Api = async (
    data,
    actionId
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + `quick-action/run/${actionId}/output-feedback`,
            data: JSON.stringify(data),
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const runQuick_Action_Uploadtext_Api = async (data, quickActionId) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url:
                BASEURL +
                `quick-action/${quickActionId}/run/create-file-from-text`,
            data: JSON.stringify(data),
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_Supporting_DocumentFolder_CreateApi = async (
    folderData
) => {
    let urldata = '';
    if (folderData.folderid === undefined) {
        urldata = 'create';
    } else {
        urldata = 'update';
    }
    try {
        const formData = new FormData();
        formData.append('workspace_id', folderData.workspace_id);
        formData.append('folder_name', folderData.folder_name);
        formData.append('notes', folderData.notes);
        formData.append('created_by_name', folderData.created_by_name);
        if (folderData.logo != null && folderData.logo != undefined) {
            formData.append('logo', folderData.logo);
        }
        formData.append('is_restricted', folderData.is_restricted);
        formData.append('folder_id', folderData.folderid);
        formData.append('client_ids', JSON.stringify(folderData.client_ids));
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
            method: 'POST',
            url: BASEURL + `public-workspace/folder/${urldata}`,
            data: formData,
        });
        console.log('res', res);
        return res;
    } catch (err) {
        return err;
    }
};

export const Get_Output_history_List_Api = async (quickActionId, actionId) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url:
                BASEURL +
                `quick-action/${quickActionId}/run/${actionId}/get-list-of-output-history`,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const Post_Save_Edit_Output_history_Api = async (
    data,
    quickActionId,
    actionId
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url:
                BASEURL +
                `quick-action/${quickActionId}/run/${actionId}/save-edit-output-history`,
            data: JSON.stringify(data),
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const Restored_Edited_Output_History_Api = async (
    quickActionId,
    actionId,
    historyId
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url:
                BASEURL +
                `quick-action/${quickActionId}/run/${actionId}/output-history/${historyId}/set-as-restored`,
            data: JSON.stringify({}),
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const Rename_Title_Edit_history_Api = async (
    data,
    quickActionId,
    actionId,
    historyId
) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url:
                BASEURL +
                `quick-action/${quickActionId}/run/${actionId}/output-history/${historyId}/rename-title`,
            data: JSON.stringify(data),
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const workspace_Supporting_DocumentFolder_EditApi = async (
    folderData
) => {
    try {
        const formData = new FormData();
        formData.append('workspace_id', folderData.workspace_id);
        formData.append('folder_name', folderData.folder_name);
        formData.append('notes', folderData.notes);
        formData.append('created_by_name', folderData.created_by_name);
        if (folderData.folder_id != null && folderData.folder_id != undefined) {
            formData.append('folder_id', folderData.folder_id);
        }
        if (folderData.logo != null && folderData.logo != undefined) {
            formData.append('logo', folderData.logo);
        }
        formData.append('is_restricted', folderData.is_restricted);
        formData.append(
            'public_folder_workspace_access',
            JSON.stringify(folderData.public_folder_workspace_access)
        );
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
            method: 'PATCH',
            url: BASEURL + `public-workspace/folder/update`,
            data: formData,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const getClientsDataList = async (searchKey) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + `public-workspace/client/list`,
        });

        return res;
    } catch (err) {
        return err;
    }
};
export const getWorkspaceDataList = async (id) => {
    console.log('id', id);
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url: BASEURL + `public-workspace/client/workspace/list`,
            data: {
                client_id: id,
            },
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const SettingsClientWorkSpaceAnalyticsApi = async (client_id) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url:
                BASEURL +
                `public-workspace/client/workspace/list?client_id=${client_id}`,
        });
        return res;
    } catch (err) {
        return err;
    }
};

export const quick_Action_Run_Check_Api = async (UserId) => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'POST',
            url:
                BASEURL +
                `quick-action/${UserId}/get-qa-actions-status
      `,
        });
        return res;
    } catch (err) {
        return err;
    }
};


export const workspace_CustomList = async () => {
    try {
        const token = localStorage.getItem('token');
        const res = await authAxios({
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'GET',
            url: BASEURL + 'quick-action/custom-quick-action-list',
        });

        return res;
    } catch (err) {
        return err;
    }
};